module.exports = __webpack_public_path__ + "static/media/dark-theme-idling.24abe406.svg";